// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"907":"898787c0","938":"af0e7bd5"}[chunkId] + ".chunk.css";
};